import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "no-account" }
const _hoisted_9 = { class: "help-text mb-5" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "account-exists text-left" }
const _hoisted_13 = { class: "alert alert-warning" }
const _hoisted_14 = { class: "help-text mt-3 text-center" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ErrorWidget = _resolveComponent("ErrorWidget")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-body landing-body", [_ctx.isSignup ? 'page-signup' : 'page-signin',
                {'page-account-exists': _ctx.accountExists},
                {'account-fybn': _ctx.accountFirebaseYesBackendNo}]])
  }, [
    _createVNode(_component_Header),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["card-header title-sign-up", [_ctx.isSignup ? 'd-block' : 'd-none']])
            }, [
              _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "title" }, "Create GanttProject Cloud Account", -1)),
              _createElementVNode("div", null, [
                _cache[3] || (_cache[3] = _createTextVNode(" Are you already registered here? ", -1)),
                _createElementVNode("a", {
                  href: _ctx.routes.LOGIN,
                  class: "link"
                }, "Sign in", 8, _hoisted_5),
                _cache[4] || (_cache[4] = _createTextVNode(" to your account. ", -1))
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["card-header title-sign-in", [_ctx.isSignup ? 'd-none' : 'd-block']])
            }, [
              _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "title" }, "Sign In to GanttProject Cloud", -1)),
              _createElementVNode("div", null, [
                _cache[6] || (_cache[6] = _createTextVNode(" New to GanttProject cloud? ", -1)),
                _createElementVNode("a", {
                  href: _ctx.routes.SIGNUP,
                  class: "link"
                }, "Create an account", 8, _hoisted_6)
              ])
            ], 2),
            _createElementVNode("div", _hoisted_7, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { id: "firebaseui-auth-container" }, null, -1)),
              _createElementVNode("div", _hoisted_8, [
                _cache[8] || (_cache[8] = _createElementVNode("h3", null, "You must be new here!", -1)),
                _createElementVNode("p", _hoisted_9, "No account found for " + _toDisplayString(_ctx.signedInEmail || 'this email address') + ".", 1),
                _createElementVNode("a", {
                  href: _ctx.routes.SIGNUP,
                  class: "btn btn-attention w-100"
                }, "Sign Up", 8, _hoisted_10),
                _createElementVNode("a", {
                  href: _ctx.routes.LOGIN,
                  class: "btn btn-outline-secondary mt-3 w-100",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.signOutAndSignin && _ctx.signOutAndSignin(...args)), ["prevent"]))
                }, "Sign in with a different account", 8, _hoisted_11)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", _hoisted_13, "An account associated with " + _toDisplayString(_ctx.signedInEmail || 'this email address') + " already exists.", 1),
                _cache[9] || (_cache[9] = _createElementVNode("p", { class: "m-5" }, "Would you like to sign in with this account or start over with another email address?", -1)),
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-attention w-100",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.redirectToPostAuth && _ctx.redirectToPostAuth(...args)), ["prevent"]))
                }, "Continue and sign in"),
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-outline-secondary mt-3 w-100",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.signOutAndSignup && _ctx.signOutAndSignup(...args)), ["prevent"]))
                }, "Try another account")
              ]),
              _cache[14] || (_cache[14] = _createElementVNode("div", { id: "loader" }, [
                _createElementVNode("i", { class: "fa fa-spin fa-spinner" }),
                _createTextVNode(" Loading…")
              ], -1)),
              _createElementVNode("div", _hoisted_14, [
                _cache[10] || (_cache[10] = _createTextVNode(" We do not store your passwords and do not sell your personal information. ", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("a", {
                  href: _ctx.routes.ABOUT_TOS,
                  class: "link",
                  target: "_blank"
                }, "Terms of Service", 8, _hoisted_15),
                _cache[12] || (_cache[12] = _createTextVNode(" |  ", -1)),
                _createElementVNode("a", {
                  href: _ctx.routes.ABOUT_PRIVACY,
                  class: "link",
                  target: "_blank"
                }, "Privacy Policy", 8, _hoisted_16)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_ErrorWidget, { ref: "errorWidget" }, null, 512)
  ], 2))
}